import { createVNode, render, h } from 'vue'
import ScanatModal from './Modal.vue'


let modalInstance = null

const defaultOptions = {
  title: '',
  content: '',
  visible: true,
  showConfirmButton: true,
  showCancelButton: true,
  confirmButtonText: '确定',
  cancelButtonText: '关闭',
  closeOnClickModal: true,
  size: '',
  topOffset: '0',
  customWidth: '',
  customHeight: ''
}

const createModalContainer = () => {
  const container = document.createElement('div')
  container.className = 'scanat-modal-container'
  document.body.appendChild(container)
  return container
}

const removeModalContainer = (container) => {
  if (container && container.parentNode) {
    container.parentNode.removeChild(container)
  }
}

const ModalService = {
  /**
   * 打开弹窗
   * @param {Object} options 弹窗选项
   * @returns {Promise} 返回一个Promise，resolve为确认，reject为取消
   */
  open(options = {}) {
    return new Promise((resolve, reject) => {
      const { content, ...restOptions } = options

      const modalOptions = {
        ...defaultOptions,
        ...restOptions
      }

      const container = createModalContainer()

      const handleDestroy = () => {
        if (modalInstance) {
          render(null, container)
          removeModalContainer(container)
          modalInstance = null
        }
      }

      const handleConfirm = (data) => {
        resolve(data || true)
        handleDestroy()
      }

      const handleCancel = () => {
        reject(new Error('Modal was canceled'))
        handleDestroy()
      }

      const vnode = createVNode(ScanatModal, {
        ...modalOptions,
        visible: true,
        'onUpdate:visible': (val) => {
          if (!val) {
            handleCancel()
          }
        },
        onConfirm: handleConfirm,
        onCancel: handleCancel
      })

      if (content !== undefined) {
        vnode.children = [this.renderContent(content)]
      }

      render(vnode, container)
      modalInstance = vnode
    })
  },

  /**
   * 渲染内容
   * @param {String|VNode|Function|Array|Object} content - 要渲染的内容
   * @returns {VNode} 虚拟节点
   */
  renderContent(content) {
    if (typeof content === 'string') {
      return content
    }

    if (content && typeof content === 'object' && content.type) {
      return content
    }

    if (typeof content === 'function') {
      return content()
    }

    if (Array.isArray(content)) {
      return h('div', {}, content)
    }

    if (content && typeof content === 'object') {
      try {
        return h('div', { innerHTML: content.html || '' })
      } catch (e) {
        console.error('Failed to render content:', e)
        return h('div', {}, JSON.stringify(content))
      }
    }

    return String(content || '')
  },

  /**
   * 确认弹窗快捷方法
   * @param {String|Object} titleOrOptions 标题或完整配置对象
   * @param {String|VNode|Function} content 内容
   * @returns {Promise}
   */
  confirm(titleOrOptions, content) {
    const options = typeof titleOrOptions === 'object'
      ? titleOrOptions
      : { title: titleOrOptions, content }

    return this.open({
      ...options,
      showCancelButton: true,
      showConfirmButton: true
    })
  },

  /**
   * 提示弹窗快捷方法
   * @param {String|Object} titleOrOptions 标题或完整配置对象
   * @param {String|VNode|Function} content 内容
   * @returns {Promise}
   */
  alert(titleOrOptions, content) {
    const options = typeof titleOrOptions === 'object'
      ? titleOrOptions
      : { title: titleOrOptions, content }

    return this.open({
      ...options,
      showCancelButton: false,
      showConfirmButton: true
    })
  },

  close() {
    if (modalInstance && modalInstance.component) {
      modalInstance.component.proxy.visible = false
    }
  }
}

const createModalPlugin = {
  install(app) {
    app.config.globalProperties.$modal = ModalService
    app.provide('$modal', ModalService)
    app.component('ScanatModal', ScanatModal)
  }
}

export { ModalService, createModalPlugin }
export default createModalPlugin